import { render, staticRenderFns } from "./TaxInvoiceRecord.vue?vue&type=template&id=9a186826&scoped=true&"
import script from "./TaxInvoiceRecord.vue?vue&type=script&lang=js&"
export * from "./TaxInvoiceRecord.vue?vue&type=script&lang=js&"
import style0 from "./TaxInvoiceRecord.vue?vue&type=style&index=0&id=9a186826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a186826",
  null
  
)

export default component.exports